import React from 'react';
import PropTypes from 'prop-types';


const TextAttr = function TextAttrComponent({ value }) {
  return <span>{value || '-'}</span>;
};

TextAttr.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string,
    PropTypes.number,
    PropTypes.arrayOf(PropTypes.string)]),
};

TextAttr.defaultProps = {
  value: null,
};

export default TextAttr;
